export const paramsArePresent = (
  params: URLSearchParams,
  ...paramsToSearchFor: string[]
): boolean => {
  let result = true;
  const paramArray = [...params.keys()];
  paramsToSearchFor.forEach((param) => {
    result &&= paramArray.includes(param);
  });

  return result;
};
